import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Pricing from '../data/Pricing';
import { SourceContext } from './sourceContext';
import { trackPostHogEvent } from './posthogUtils';

export const handleRedirect = async () => {
    const pricing = Pricing();
    const source = localStorage.getItem('source') ?? 'nocookie';
    const prices = await pricing.getPrices();
    const redirectUrl = prices.myStartClickUrl + source;

    try {
        const response = await fetch(process.env.REACT_APP_TB2_API_URL + '/events/redirect', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                source: localStorage.getItem('source'),
                subdomain: localStorage.getItem('subdomain'),
                redirectUrl: redirectUrl,
            }),
        });

        const data = await response.json();
        console.log(data);
    } catch (error) {
        console.error('Error capturing redirect:', error);
    } finally {
        window.location.href = redirectUrl;
    }
};

// Enhanced navigation hook that uses React Router for internal navigation
export const useNavigation = () => {
    const { isMyStart } = useContext(SourceContext);
    const reactNavigate = useNavigate();
    
    return (targetUrl = '/checkout/plan-selection', options = {}) => {
        // Track navigation events for interview steps
        if (targetUrl.startsWith('/interview/')) {
            trackPostHogEvent('interview_step_navigation', {
                from_path: window.location.pathname,
                to_path: targetUrl,
                interview_step: targetUrl.replace('/interview/', ''),
                is_mystart_user: isMyStart
            });
        }
        
        // Handle MyStart redirects for entry points to the funnel
        if (isMyStart && (targetUrl === '/checkout' || targetUrl === '/checkout/plan-selection' || targetUrl === '/interview/decision')) {
            // For MyStart users, redirect to external site instead of internal flow
            handleRedirect();
        } else {
            // For all other cases, use React Router navigation
            if (targetUrl.startsWith('/')) {
                // Internal route - use React Router to preserve browser history
                reactNavigate(targetUrl, options);
            } else {
                // External URL - use window.location.href
                window.location.href = targetUrl;
            }
        }
    };
};
